import { Point } from './point';

export class PointsSummary {
  points: Point[];
  averageSpeed: number;
  averageFuelConsumption: number;
  averageRpm: number;
  distanceTravelled: number;
}
